import { useParams } from 'react-router-dom';
import { TechOnboarder } from '../../components/TechOnboarder';
import { useSourceTypes } from '../../hooks/useSourceTypes';

export default function OnboardingConversationPage() {
  const { id } = useParams<{ id: string }>();
  // Pre-fetch source types so ConnectorIcon has cached data when tool calls render
  useSourceTypes();

  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border">
        <h1 className="text-2xl font-bold text-foreground">Onboarding</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Get your data connected and organized with guided assistance.
        </p>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        {id && <TechOnboarder showHistory={true} conversationId={id} />}
      </div>
    </div>
  );
}
